import styled from 'styled-components';

import type { LinkProps } from '@xing-com/link';
import { Link as CrateLink } from '@xing-com/link';
import { spaceS, xdlColorText } from '@xing-com/tokens';

export const Link = styled(CrateLink)<LinkProps>`
  color: ${xdlColorText};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spaceS};

  &:hover,
  &:focus {
    text-decoration: none;
  }

  position: relative;
`;
